import React from 'react';
import { Box, Typography, Chip, Grid, Card, CardContent } from '@mui/material';

const TaskProgressSection = ({ taskProgress, getUserName }) => {
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('pl-PL');
  };

  return (
    <Grid item xs={12}>
      <Card>
        <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Task Progress</Typography>
          {taskProgress?.length > 0 ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {[...taskProgress].sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).map((progress) => {
                const createdByName = getUserName ? getUserName(progress.created_by) : `User ${progress.created_by}`;
                return (
                  <Box key={progress.id} sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 1, border: '1px solid', borderColor: 'grey.200' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                      <Typography variant="caption" color="text.secondary">
                        {formatDate(progress.created_at)} by {createdByName}
                      </Typography>
                      <Chip label={`${progress.progress}%`} size="small" color="primary" />
                    </Box>
                    {progress.content && (
                      <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                        {progress.content}
                      </Typography>
                    )}
                    {progress.end_date && (
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                        End date: {formatDate(progress.end_date)}
                      </Typography>
                    )}
                    {progress.attachments?.length > 0 && (
                      <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 1 }}>
                        {progress.attachments.map((attachment, idx) => (
                          <Chip 
                            key={idx}
                            label={attachment.data_file_name}
                            variant="outlined"
                            size="small"
                            color="info"
                            onClick={() => window.open(attachment.url, '_blank')}
                            sx={{ cursor: 'pointer' }}
                          />
                        ))}
                      </Box>
                    )}
                  </Box>
                );
              })}
            </Box>
          ) : (
            <Typography variant="body2" color="text.secondary">
              No progress updates
            </Typography>
          )}
        </CardContent>
      </Card>
    </Grid>
  );
};

export default TaskProgressSection;
